export enum VersionCompare {
	IDENTICAL_VERSIONS,
	LOCAL_VERSION_HIGHER,
	REMOTE_VERSION_HIGHER
}